/* eslint-disable @typescript-eslint/consistent-type-assertions */
import type { MachineModelHealthStatus, MachineModelHealthStatusResource } from "@octopusdeploy/octopus-server-client";
import { MachineModelHealthStatusValues } from "@octopusdeploy/octopus-server-client";
import { each } from "lodash";
export default class MachineHealthStatusHelper {
    public static getFriendlyName(status: MachineModelHealthStatus) {
        if (status === MachineModelHealthStatusValues.Healthy) {
            return "Healthy";
        }
        else if (status === MachineModelHealthStatusValues.Unavailable) {
            return "Unavailable";
        }
        else if (status === MachineModelHealthStatusValues.Unknown) {
            return "Unknown";
        }
        else if (status === MachineModelHealthStatusValues.HasWarnings) {
            return "Healthy with warnings";
        }
        else if (status === MachineModelHealthStatusValues.Unhealthy) {
            return "Unhealthy";
        }
        return status;
    }
    public static getMachineModelHealthStatusResources(): MachineModelHealthStatusResource[] {
        // Could hardcode this, but if we add other enums, this future proofs it.
        const statuses: MachineModelHealthStatusResource[] = [];
        const objValues = Object.keys(MachineModelHealthStatusValues).map((k) => MachineModelHealthStatusValues[k as MachineModelHealthStatus]);
        const names = objValues.filter((v) => typeof v === "string") as string[];
        each(names, (statusText) => {
            const statusEnum = statusText as MachineModelHealthStatus;
            const name = MachineHealthStatusHelper.getFriendlyName(statusEnum);
            const status: MachineModelHealthStatusResource = {
                Id: statusEnum,
                Name: name,
            };
            statuses.push(status);
        });
        return statuses;
    }
}
